<div class="c-contenedor">
  <div class="row">
    <div class="col-12 p-0">
      <img class="icon-info pl-10" src="assets/icons/icon-info-blue.svg" alt="info">
      <img class="icon-close pr-10" (click)="onCloseClick()" src="assets/icons/ico-close.png" alt="cerrar">
    </div>
  </div>

  <div class="row">
    <div class="col-12 mt-2">
      <h1 class="dialog-title"> Cobro adicional por rubro</h1>
    </div>
    <div class="col-12">
      <span class="dialog-sub">Según el rubro de tu comercio, las marcas Visa, Mastercard y Amex, podrían generar un
        cobro que será reflejado en tu contratación.</span>
    </div>
    <div class="col-12  mt-4">
      <table class="dialog-table">
        <thead>
          <tr>
            <th class="primary-text">Marca</th>
            <th class="primary-text">Cobro anual</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="primary-text">Aceptación de transacción MasterCard</td>
            <td class="secondary-text">
              <span *ngIf="this.precioMastercard > 0; else sinCobro">
                USD {{this.precioMastercard}} por código de comercio + impuestos*
              </span>
              <ng-template #sinCobro>
                Sin cobro
              </ng-template>
            </td>
          </tr>
          <tr>
            <td class="primary-text">Aceptación de transacción Visa</td>
            <td class="secondary-text">
              <span *ngIf="this.precioVisa > 0; else sinCobro">
                USD {{this.precioVisa}} por rubro + impuestos*
              </span>
              <ng-template #sinCobro>
                Sin cobro
              </ng-template>
            </td>
          </tr>
          <tr>
            <td class="primary-text">Aceptación de transacciones Amex</td>
            <td class="secondary-text">
              <span *ngIf="this.precioAmex > 0; else sinCobro">
                USD {{this.precioAmex}}
              </span>
              <ng-template #sinCobro>
                Sin cobro
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12 mt-2">
      <span class="dialog-disclaimer">* Los impuestos aplicables son responsabilidad del comercio. El contrato se
        renueva automáticamente.</span>
    </div>
    <div class="dialog-footer col-12 mt-4">
      <span>
        Para más detalles sobre Servicios y Tarifas para Comercios, consulta este
        <a href="{{urlDocServTarifas}}" rel="noopener noreferrer" target="_blank">documento</a>.
      </span>
    </div>
    <div class="col-12 mt-4">
      <mat-dialog-actions>
          <button (click)="onCloseClick()" class="btn-primary-tbk mx-auto dis">Entendido</button>
      </mat-dialog-actions>
  </div>
  </div>
</div>